import React from 'react';

import { defaultTextStyle, colors } from 'settings/theme';

export default function RadioButton(props) {
    const {
        value,
        label,
        selected,
        onClick,
        style,
        radioButtonAlignment = 'center',
        ...restProps,
    } = props;

    const validRadioButtonAlignments = ['top', 'center'];
    if (!validRadioButtonAlignments.includes(radioButtonAlignment)) {
        throw new Error(`radioButtonAlignment must be one of ${validRadioButtonAlignments}. Got: ${radioButtonAlignment}`)
    }

    return (
        <div
            style={{
                display: 'flex',
                alignItems: radioButtonAlignment === 'top' ? 'flex-start' : 'center',
                ...style,
            }}
            onClick={() => onClick(value)}
            {...restProps}
        >
            <span
                className="stylized-radio"
                style={{
                    position: 'relative',
                    marginTop: 0,
                }}
            >
                <input
                    type="radio"
                    className="stylized-radio-input"
                    value={value}
                />
                <label
                    style={{
                        border: selected ? `2px solid ${colors.blueMid}` : `1px solid ${colors.border}`,
                    }}
                />
                {selected &&
                    <div
                        style={{
                            position: 'absolute',
                            width: 10,
                            height: 10,
                            margin: 3,
                            background: colors.blueMid,
                            borderRadius: '50%',
                            top: 2,
                            left: 5,
                        }}
                    />
                }
            </span>
            <label
                style={{
                    ...defaultTextStyle,
                    fontSize: '1.3em',
                    marginLeft: 4,
                }}
            >
                {label}
            </label>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/RadioButton.js